<component-captcha>
    <div class="col-md-12">
      <form #captchaProtectedForm="ngForm">
        <re-captcha
          [(ngModel)]="formModel.captcha"
          name="captcha"
          required
          siteKey="6LfCGh0TAAAAABaER0xUBNmGIWXFtOonw0K_goM-"
          #captchaControl="ngModel"
        ></re-captcha>
        <div [hidden]="captchaControl.valid || captchaControl.pristine" class="error">Captcha must be solved</div>
        <div [hidden]="!captchaControl.valid" class="success">Captcha is valid</div>
        <div [hidden]="captchaProtectedForm.form.valid" class="error">The form must be filled out</div>
        <div [hidden]="!captchaProtectedForm.form.valid" class="success">The form is valid</div>
        <button (click)="formModel.captcha = ''">Reset Captcha</button>
      </form>
    </div>
</component-captcha>